"use strict"; // Copyright 2019 The FairDataSociety Authors
// This file is part of the FairDataSociety library.
//
// The FairDataSociety library is free software: you can redistribute it and/or modify
// it under the terms of the GNU Lesser General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// The FairDataSociety library is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
// GNU Lesser General Public License for more details.
//
// You should have received a copy of the GNU Lesser General Public License
// along with the FairDataSociety library. If not, see <http://www.gnu.org/licenses/>.

var _classCallCheck = require("C:\\Users\\tex\\source\\repos\\DataFund\\dr-editor-sample\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\tex\\source\\repos\\DataFund\\dr-editor-sample\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var Contact =
/*#__PURE__*/
function () {
  function Contact(attrs) {
    _classCallCheck(this, Contact);

    if (attrs.subdomain === undefined) throw new Error('subdomain must be defined');
    if (attrs.publicKey === undefined) throw new Error('publicKey must be defined');
    if (attrs.multiboxAddress === undefined) throw new Error('mailboxAddress must be defined');
    if (attrs.feedLocationHash === undefined) throw new Error('feedLocationHash must be defined');
    this.subdomain = attrs.subdomain;
    this.publicKey = attrs.publicKey;
    this.multiboxAddress = attrs.multiboxAddress;
    this.feedLocationHash = attrs.feedLocationHash;
    return this;
  }

  _createClass(Contact, [{
    key: "toJSON",
    value: function toJSON() {
      return {
        subdomain: this.subdomain,
        publicKey: this.publicKey,
        multiboxAddress: this.multiboxAddress,
        feedLocationHash: this.feedLocationHash
      };
    }
  }]);

  return Contact;
}();

module.exports = Contact;